var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('st-filters-pagination',{ref:"filters",attrs:{"header":_vm.$t('ACCOUNTS.LIST.HEADER'),"perPage":10,"total":_vm.total,"stateModule":"accounts","filters":_vm.filters},on:{"change":_vm.doFilter}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }